export default __webpack_public_path__ + "static/media/Img0004.6e34480a.png";